import { ContractProvider } from "../../provider/ContractProvider";
import Agreement from "../UI/Profile/ProfileCard/Contract/Agreement";
const AgreementPage = () => {
  return (
    <ContractProvider>
      <Agreement />
    </ContractProvider>
  );
};

export default AgreementPage;
